import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { InvoiceDraft } from '@features/invoices/types/invoiceDraft'
import { InvoicePayload } from '@features/invoices/types/invoicePayload/invoicePayload'
import { getInvoicingApiCategory } from '@features/invoices/utils/getInvoicingApiCategory'
import { isDocumentTypeCreditNote } from '@features/invoices/utils/isDocumentTypeCreditNote'

import apiZervant from '../../utils/apiZervant'
import { InvoiceNumberingSequence } from './types/InvoiceNumberingSequence'

// restInvoice requests

export type FetchInvoiceHtmlResponse = string

export const fetchInvoiceHtml = async (invoiceId: string, documentType: InvoiceDocumentType) => {
  return apiZervant.restInvoice.get<FetchInvoiceHtmlResponse>(
    isDocumentTypeCreditNote(documentType) ? `/creditnotes/${invoiceId}/html` : `/invoices/${invoiceId}/html`,
  )
}

type FetchInvoiceNumberingSequencesResponseData = InvoiceNumberingSequence[]

export const fetchInvoiceNumberingSequences = async () => {
  return apiZervant.restInvoice.get<FetchInvoiceNumberingSequencesResponseData>('/invoices/number')
}

type FetchNextQuoteNumberResponseData = { invoicenumber: number }

export const fetchNextQuoteNumber = async () => {
  return apiZervant.restInvoice.get<FetchNextQuoteNumberResponseData>('/estimates/number/next')
}

export interface CreateInvoiceNumberingSequencePayload {
  base: number
  prefix: string | null
}

export type CreateInvoiceNumberingSequenceResponseData = InvoiceNumberingSequence

export const createInvoiceNumberingSequence = (payload: CreateInvoiceNumberingSequencePayload) => {
  return apiZervant.restInvoice.post<CreateInvoiceNumberingSequenceResponseData>('/invoices/number', payload)
}

interface CreateInvoiceDraftOptions {
  payload: InvoicePayload
  documentType: InvoiceDocumentType
}

interface CreateInvoiceDraftResponseData {
  id: number
}

export const createInvoiceDraft = ({ payload, documentType }: CreateInvoiceDraftOptions) => {
  const apiCategory = getInvoicingApiCategory(documentType)
  return apiZervant.restInvoice.post<CreateInvoiceDraftResponseData>(`/drafts/${apiCategory}`, payload)
}

type UpdateInvoiceDraftOptions = CreateInvoiceDraftOptions

type UpdateInvoiceDraftResponseData = CreateInvoiceDraftResponseData

export const updateInvoiceDraft = ({ payload, documentType }: UpdateInvoiceDraftOptions) => {
  const { id: invoiceDraftId } = payload
  const apiCategory = getInvoicingApiCategory(documentType)
  return apiZervant.restInvoice.put<UpdateInvoiceDraftResponseData>(`/drafts/${apiCategory}/${invoiceDraftId}`, payload)
}

type FetchSalesDocumentDraftResponseData = InvoiceDraft

export const fetchSalesDocumentDraft = (draftId: string, documentType: InvoiceDocumentType) => {
  const apiCategory = getInvoicingApiCategory(documentType)
  return apiZervant.restInvoice.get<FetchSalesDocumentDraftResponseData>(`/drafts/${apiCategory}/${draftId}`)
}

interface ApproveInvoiceOptions {
  invoiceDraftId: number
  documentType: InvoiceDocumentType
}

// Invoice approval's response is an array, while credit note approval's response is an object
export type ApproveInvoiceResponseData = { id: number }[] | { id: number }

export const approveInvoice = ({ invoiceDraftId, documentType }: ApproveInvoiceOptions) => {
  const apiCategory = getInvoicingApiCategory(documentType)
  return apiZervant.restInvoice.put<ApproveInvoiceResponseData>(`/drafts/${apiCategory}/${invoiceDraftId}/approve`)
}
